import useBinaryEncryption from './useBinaryEncryption';
import { AboboCrypto } from '@utils/aboboCrypto';

const useBase64Encryption = () => {
  const binaryEncrypt = useBinaryEncryption();

  const encrypt = async (input: string) => {
    const { encryptedValue, encryptionKey } = await binaryEncrypt(input);

    return { encryptedValue: AboboCrypto.uInt8ArrayToBase64(encryptedValue), encryptionKey };
  };

  return encrypt;
};

export default useBase64Encryption;
